module.exports = "/src/views/player/help/images/zoo2.jpg";